module.exports = __webpack_public_path__ + "img/RVillager64_ua.1d6bb6de.webp";